import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { Clock, Home, Camera, Check } from "lucide-react";

export default function ServiceDetail() {
  const { id } = useParams();
  const { t, localize, fmtSAR, isAr } = useI18n();
  const nav = useNavigate();
  const [s, setS] = useState(null);

  useEffect(() => { api.get(`/services/${id}`).then((r) => setS(r.data)).catch(() => {}); }, [id]);
  if (!s) return <div className="mx-auto max-w-7xl px-4 py-20 text-center text-slate-400">{t("common.loading")}</div>;

  const book = () => nav(`/booking?service=${id}`);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div className="overflow-hidden rounded-3xl"><img src={s.image} alt="" className="h-full w-full object-cover" /></div>
        <div>
          <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{localize(s, "name")}</h1>
          <p className="mt-3 text-lg leading-relaxed text-slate-600">{localize(s, "desc")}</p>
          <div className="mt-5 flex flex-wrap gap-4 text-sm text-slate-500">
            <span className="inline-flex items-center gap-1.5"><Clock className="h-4 w-4 text-primary" /> {s.duration_minutes} {t("common.minutes")}</span>
            {s.location_types?.includes("home") && <span className="inline-flex items-center gap-1.5"><Home className="h-4 w-4 text-[hsl(var(--brand-orange))]" /> {t("booking.at_home")}</span>}
            {s.full_studio && <span className="inline-flex items-center gap-1.5"><Camera className="h-4 w-4 text-[hsl(var(--brand-red))]" /> {isAr ? "الاستوديو كاملاً" : "Full studio"}</span>}
          </div>
          <div className="mt-6 rounded-2xl border border-border bg-white p-5">
            <div className="text-sm text-slate-400">{t("common.from")}</div>
            <div className="text-3xl font-extrabold text-primary">{fmtSAR(s.price)}</div>
            <div className="mt-1 text-xs text-slate-400">{isAr ? "شامل ضريبة القيمة المضافة عند الدفع" : "VAT applied at checkout"}</div>
          </div>
          <button onClick={book} data-testid="service-book-btn" className="mt-6 w-full rounded-full bg-primary py-3.5 text-lg font-semibold text-white shadow-lg transition-all hover:scale-[1.02] active:scale-95">{t("nav.book")}</button>
        </div>
      </div>

      {s.packages?.length > 0 && (
        <section className="mt-14">
          <h2 className="mb-6 text-2xl font-bold text-slate-900">{t("booking.choose_package")}</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {s.packages.map((p) => (
              <div key={p.id} className="rounded-2xl border border-border bg-white p-6 transition-all hover:shadow-lg">
                <h3 className="text-lg font-bold text-slate-900">{localize(p, "name")}</h3>
                <p className="mt-1 text-sm text-slate-500">{localize(p, "desc")}</p>
                <div className="mt-4 text-2xl font-extrabold text-primary">{fmtSAR(p.price)}</div>
              </div>
            ))}
          </div>
        </section>
      )}

      {s.addons?.length > 0 && (
        <section className="mt-12">
          <h2 className="mb-6 text-2xl font-bold text-slate-900">{t("booking.addons")}</h2>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {s.addons.map((a) => (
              <div key={a.id} className="flex items-center justify-between rounded-xl border border-border bg-white p-4">
                <span className="inline-flex items-center gap-2 text-sm font-medium text-slate-700"><Check className="h-4 w-4 text-[hsl(var(--brand-orange))]" /> {localize(a, "name")}</span>
                <span className="font-bold text-primary">{fmtSAR(a.price)}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
